import api from '@/services/api';

export function listTemplates({
    page = 1,
    limit = 20,
    topic = '',
    teacherId = null,
    subjectId = null,
    scope = 'all',
    feedbackLetterId = null
} = {}) {
    const params = new URLSearchParams({ page, limit });
    if (topic) params.set('topic', topic);
    if (Number.isFinite(Number(teacherId)) && Number(teacherId) > 0) {
        params.set('teacher_id', String(Number(teacherId)));
    }
    if (Number.isFinite(Number(subjectId)) && Number(subjectId) > 0) {
        params.set('subject_id', String(Number(subjectId)));
    }
    if (scope) params.set('scope', String(scope));
    if (Number.isFinite(Number(feedbackLetterId)) && Number(feedbackLetterId) > 0) {
        params.set('feedback_letter_id', String(Number(feedbackLetterId)));
    }
    return api.get(`/feedback-templates?${params.toString()}`).then(r => r.data);
}

export function getTemplate(id) {
    return api.get(`/feedback-templates/${id}`).then(r => r.data);
}

export function createTemplate(payload) {
    return api.post('/feedback-templates', payload).then(r => r.data);
}

export function updateTemplate(id, payload) {
    return api.put(`/feedback-templates/${id}`, payload).then(r => r.data);
}

export function deleteTemplate(id) {
    return api.delete(`/feedback-templates/${id}`).then(r => r.data);
}